<template>
  <div v-if="order">
    <!-- 指示メモ -->
    <v-card-title>
      <span style="color: #0074BA">指示メモ</span>&emsp;
      <v-btn
        v-if="canShowEditButton"
        small
        @click="enableDialogButtonClickEvent"
      >
        <v-icon small>
          mdi-pencil
        </v-icon>
        &nbsp;編集
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-textarea
            v-model="order.driver_instruction"
            dense
            hide-details="true"
            label="ドライバー指示メモ"
            no-resize
            outlined
            readonly
            persistent-placeholder
            filled
            rows="2"
          />
        </v-col>
        <v-col cols="12" md="6">
          <viewer
            v-if="files.length > 0"
            :images="files"
            :options="viewerOptions"
            class="images clearfix"
          >
            <template v-slot="scope">
              <figure class="images">
                <template
                  v-for="(attachment, index) in scope.images"
                >
                  <div
                    v-if="!attachment._destroy"
                    :key="index"
                    class="image-wrapper"
                    style="border: 1px solid #ddd;border-radius: 5px;position: relative;width: 30%;text-align: center;height: 67px;"
                  >
                    <div style="position: absolute;top: -10px;right: -10px;z-index:100;"></div>
                    <img
                      v-if="isImageContent(attachment.content_type)"
                      :alt="index"
                      :data-source="attachment.url"
                      :src="attachment.url"
                      class="image"
                      style="width: 100%;height: 100%;object-fit: contain;"
                    >
                    
                    <template
                      v-else
                    >
                      <div class="text-center">
                        <v-icon
                          size="65"
                        >
                          {{ documentIcon(attachment.content_type) }}
                        </v-icon>
                      </div>
                    </template>
                  </div>
                </template>
                <br style="clear: both;" />
              </figure>
            </template>
          </viewer>
        </v-col>
      </v-row>
      <v-row>
        <!-- 現地メモ -->
        <v-col cols="12" md="6">
          <v-textarea
            v-model="order.local_notes"
            dense
            hide-details="auto"
            label="現地メモ"
            no-resize
            outlined
            readonly
            persistent-placeholder
            filled
            rows="2"
          />
        </v-col>
        <!-- /現地メモ -->
        <!-- 報告写真 -->
          <custom-image-viewer :photos="order.photos" />
        <!-- /報告写真 -->
      </v-row>
    </v-card-text>
    <!-- /指示メモ -->
    <edit-driver-instruction-dialog
      :order-id="order.id"
      :enable-dialog="enableDriverInstructionDialog"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
  </div>
</template>

<script>

import EditDriverInstructionDialog from '../dialogs/_EditDriverInstructionDialog'
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import CustomImageViewer from '../../../../../components/CustomImageViewer.vue'
export default {
  name: 'DriverInstruction',
  components: {
    EditDriverInstructionDialog,
    Viewer,
    CustomImageViewer,
  },
  mixins: [],
  props: {
    order: {
      type: Object,
      default: () => null
    },
    canShowEditButton: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      enableDriverInstructionDialog: false,
      mdColSize: 4,
      viewerOptions: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        fullscreen: true,
      },
    }
  },
  computed: {
    /**
     * 添付ファイル一覧（viewer表示用）
     */
    files() {
      return this.order?.order_attachments || []
    }
  },
  watch: {},
  created() {
  },
  methods: {
    enableDialogButtonClickEvent () {
      this.enableDriverInstructionDialog = true
    },
    dialogCloseCallback () {
      this.enableDriverInstructionDialog = false
    },
    dialogRegisterCallBack () {
      this.dialogCloseCallback()
      this.$emit('refreshDetail')
    },
    isEmpty (val) {
      return (val === null || val === '')
    },
    /**
     * ファイル種別が画像であるかの判定
     * @param type
     * @return { boolean }
     */
    isImageContent (type) {
      return type.startsWith('image')
    },
    /**
     * ファイル種別がPDFであるかの判定
     * @param type
     * @return { boolean }
     */
    isPdfContent (type) {
      return type.endsWith('pdf')
    },
    documentIcon(type) {
      return (this.isPdfContent(type)) ? "mdi-file-pdf-box" : "mdi-file-document-outline"
    },
    convertSize (size) {
      if (this.isEmpty(size)) return size
      const kb = 1024
      const mb = Math.pow(kb, 2)

      let target = null
      let unit = 'byte'

      if (size >= mb) {
        target = mb
        unit = 'MB'
      } else if (size >= kb) {
        target = kb
        unit = 'KB'
      }
      const res = target !== null ? Math.floor((size / target) * 100) / 100 : size
      return `${res} ${unit}`
    },
  }
}
</script>

<style scoped lang="scss">
.image-wrapper {
  border: 1px solid #ddd ;
  border-radius: 5px;
  display: inline-block;
  float: left;
  margin-right: 4px;
  padding: 0;
  .image {
    height: 150px;
    cursor: pointer;
    padding: 0;
    border: none;
  }
}
</style>
